import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let height = sessionStorage.getItem("authLogin") === '1' ? 228 : 250;

export default new Vuex.Store({
  state: {
    showLoadding: false,
    showToast: "",
    // tableMaxHeight: document.body.scrollHeight == 0 ? document.documentElement.scrollHeight - height : document.body.scrollHeight- height,
    tableMaxHeight: document.body.scrollHeight == 0 ? document.documentElement.scrollHeight : document.body.scrollHeight,
    screenHeight: window.screen.height,
    errorCount: 0
  },
  mutations: {
    tableMaxHeight(state, status) {
      state.tableMaxHeight = status;
    },
    showLoadding(state, status) {
      state.showLoadding = status;
    },
    showToast(state, status) {
      state.showToast = status;
    },
    errorCountIncrease(state) {
      state.errorCount++;
    },
    errorCountDecrease(state) {
      if(state.errorCount > 0)
        state.errorCount--;
    }
  },
  actions: {
    setTableMaxHeight({ commit }, status) {
      commit("tableMaxHeight", status);
    },
    setShowLoadding({ commit }, status) {
      commit("showLoadding", status);
    },
    setShowToast({ commit }, status) {
      commit("showToast", status);
    }
  },
  getters: {
    getTableMaxHeight: state => {
      return state.tableMaxHeight;
    },
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js